import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import { bootstrapTheme } from './lib/theme.jsx';

bootstrapTheme();

createRoot(document.getElementById('root')).render(<App />);
